import { useCallback } from 'react'
import ButtonModalSortList, { ItemSortFunction } from '../../../../../../baseComponents/Sorts/ButtonModalSortList'
import { BaseButtonModalSortListProps } from '../../../../../../baseComponents/Sorts/ButtonModalSortList/types'
import { twinFetchPostText } from '../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'


interface PaymentTypesSortButtonProps extends BaseButtonModalSortListProps {
    extraWhereParams: TwinDictionary
}

const PaymentTypesSortButton: React.FC<PaymentTypesSortButtonProps> = ({ userPermissions, ...rest }) => {
    const { updateOrder } = usePaymentTypesSortButtonLogic()
    return (
        <ButtonModalSortList updateData={updateOrder} userPermissions={userPermissions} getDataFrom='/api/app/config/payment/paymentType/getAllPaymentTypes' {...rest} />
    )
}


const usePaymentTypesSortButtonLogic = () => {
    const updateOrder: ItemSortFunction = useCallback(async (data) => {
        const res = await twinFetchPostText('/api/app/config/payment/paymentType/updatePaymentTypeOrder', { paymentTypes: data })
        if (res) {
            return true
        }
        return false
    }, [])

    return { updateOrder }
}

export default PaymentTypesSortButton